(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sh-85th-timeline"] && !Shopify.designMode) return;
  try {
    
  class ShTimeline extends HTMLElement {
    #controller = new AbortController();

    connectedCallback() {
      const { signal } = this.#controller;

      this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
      this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
      this.scroller = this.querySelector('.sh-85th-timeline__nav-scroll');
      this.navShell = this.querySelector('.sh-85th-timeline__nav-shell');
      this.captionYear = this.querySelector('[data-sh-caption-year]');
      this.prevBtn = this.querySelector('[data-sh-prev]');
      this.nextBtn = this.querySelector('[data-sh-next]');

      // SH Updated: May 2026 — hover-to-preview (Meghan May 21 item 4). Img is
      // created here (not in Liquid) since its src is JS-managed per-hover; keeps
      // the markup free of an empty-src placeholder.
      this.preview = this.querySelector('[data-sh-preview]');
      this.previewImg = null;
      const previewCard = this.preview ? this.preview.querySelector('[data-sh-preview-card]') : null;
      if (previewCard) {
        this.previewImg = document.createElement('img');
        this.previewImg.className = 'sh-85th-timeline__preview-img';
        this.previewImg.loading = 'lazy';
        this.previewImg.decoding = 'async';
        this.previewImg.alt = '';
        this.previewImg.width = 140;
        this.previewImg.height = 177;
        previewCard.appendChild(this.previewImg);
      }
      this.canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

      this.years = this.tabs.map((t) => t.dataset.year);
      this.activeYear = this.dataset.defaultYear || this.years[0];

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', this.#onTabClick, { signal });
        tab.addEventListener('keydown', this.#onKeyDown, { signal });
      });

      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.#step(-1), { signal });
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.#step(1), { signal });

      // SH Updated: May 2026 — hover-to-preview wiring. Only on hover-capable
      // pointers, and only on tabs that carry preview data (mock: 1956 only).
      if (this.canHover && this.preview && this.navShell) {
        this.tabs.forEach((tab) => {
          if (!tab.dataset.previewSrc) return;
          tab.addEventListener('pointerenter', this.#onPreviewEnter, { signal });
          tab.addEventListener('focus', this.#onPreviewEnter, { signal });
          tab.addEventListener('pointerleave', this.#onPreviewLeave, { signal });
          tab.addEventListener('blur', this.#onPreviewLeave, { signal });
        });
        if (this.scroller) {
          this.scroller.addEventListener('scroll', this.#onPreviewLeave, { signal, passive: true });
        }
        // Card is fixed — hide on page scroll so it can't drift off its button.
        window.addEventListener('scroll', this.#onPreviewLeave, { signal, passive: true });
      }

      window.addEventListener('hashchange', this.#onHashChange, { signal });

      this.#applyHashOnLoad();
      this.#updateArrowState();
    }

    disconnectedCallback() {
      this.#controller.abort();
    }

    #onTabClick = (event) => {
      const year = event.currentTarget.dataset.year;
      this.#activate(year, { updateHash: true });
    };

    #onKeyDown = (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      this.#step(event.key === 'ArrowLeft' ? -1 : 1);
    };

    #onHashChange = () => {
      this.#applyHashOnLoad();
    };

    // SH Updated: May 2026 — hover-to-preview (Meghan May 21 item 4). Populate the
    // shared card from the hovered tab's data-preview-src, center it over that tab
    // (left measured relative to nav-shell, the absolute containing block), reveal.
    #onPreviewEnter = (event) => {
      const tab = event.currentTarget;
      const src = tab.dataset.previewSrc;
      if (!src || !this.preview) return;
      if (this.previewImg && this.previewImg.getAttribute('src') !== src) {
        this.previewImg.setAttribute('src', src);
        this.previewImg.setAttribute('alt', tab.dataset.previewAlt || '');
      }
      // SH Updated: Jun 2026 — Meghan Jun 4 counter-check ("it just sits on top of the dot"):
      // anchor over the • dot, not the button's right edge. The card's bottom-left corner
      // (transform-origin:left bottom + translateY(-100%)) pins to the dot's horizontal CENTER
      // and the button TOP (strip top), so the card rises straight up and sits ON the dot
      // instead of kicking out to the right. --sh-preview-nudge-x re-centers the card over that
      // point (≈ -half card width); nudge-y lifts it just clear of the strip. Falls back to the
      // button center for any year without a dot. Computed from rects → self-corrects per size.
      const btnRect = tab.getBoundingClientRect();
      const dot = tab.querySelector('.sh-85th-timeline__year-dot');
      const anchorRect = dot ? dot.getBoundingClientRect() : btnRect;
      this.preview.style.left = `${anchorRect.left + anchorRect.width / 2}px`;
      this.preview.style.top = `${btnRect.top}px`;
      this.preview.classList.add('is-visible');
    };

    #onPreviewLeave = () => {
      if (this.preview) this.preview.classList.remove('is-visible');
    };

    #applyHashOnLoad() {
      const hash = window.location.hash.replace('#', '').trim();
      if (hash && this.years.includes(hash)) {
        this.#activate(hash, { updateHash: false, focus: false });
      }
    }

    #step(direction) {
      const i = this.years.indexOf(this.activeYear);
      const next = i + direction;
      if (next < 0 || next >= this.years.length) return;
      this.#activate(this.years[next], { updateHash: true });
    }

    #activate(year, { updateHash = false, focus = true } = {}) {
      if (year === this.activeYear) return;

      const swap = () => {
        this.tabs.forEach((tab) => {
          const match = tab.dataset.year === year;
          tab.setAttribute('aria-selected', match ? 'true' : 'false');
          tab.setAttribute('tabindex', match ? '0' : '-1');
          if (match && focus) tab.focus({ preventScroll: true });
          if (match) tab.scrollIntoView({ behavior: 'smooth', inline: 'center', block: 'nearest' });
        });

        this.panels.forEach((panel) => {
          const match = panel.dataset.year === year;
          if (match) {
            panel.hidden = false;
            panel.setAttribute('data-active', 'true');
          } else {
            panel.hidden = true;
            panel.setAttribute('data-active', 'false');
          }
        });

        this.activeYear = year;
        if (this.captionYear) this.captionYear.textContent = year;
        this.#updateArrowState();
      };

      if (typeof document.startViewTransition === 'function' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        document.startViewTransition(swap);
      } else {
        swap();
      }

      if (updateHash) {
        history.replaceState(null, '', `#${year}`);
      }
    }

    #updateArrowState() {
      const i = this.years.indexOf(this.activeYear);
      if (this.prevBtn) this.prevBtn.disabled = i <= 0;
      if (this.nextBtn) this.nextBtn.disabled = i >= this.years.length - 1;
    }
  }

  if (!customElements.get('sh-timeline')) {
    customElements.define('sh-timeline', ShTimeline);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();
})();
